import { store, storedState, AUTH_STATE_AUTHED, AUTH_STATE_AUTHING } from './store'
import config from './firebaseRef'
import firebase from 'firebase'

// firebase.initializeApp(config['eagle'])
firebase.initializeApp(config['evo-ip'])

const userRef = firebase.database().ref('user')

async function checkUserProfile ({uid, email}) {
  let snapshot = await userRef.once('value')
  if (!snapshot.hasChild(uid)) {
    userRef.child(uid).set({
      role: 'vendor',
      email
    })
  } else {
    let userProfileRef = await userRef.child(uid).once('value')
    console.log(userProfileRef.val())
    store.dispatch('userProfile', userProfileRef.val())
  }
}

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    // login success fires
    console.log(user)
    checkUserProfile(user)
  }
  store.dispatch('user', user || {})
  // initial no log and loging-out fire
  store.dispatch('authed', user !== null)
})

function delay (sec = 1) {
  if (sec > 10) return console.log('delay cannot bigger than 10s')
  return new Promise(resolve => {
    setTimeout(resolve, sec * 1000)
  })
}

export function login (...arg) {
  return firebase.auth().signInWithEmailAndPassword(...arg)
}

export function resetPassword (mail) {
  return firebase.auth().sendPasswordResetEmail(mail)
}

export function firebaseLogout () {
  return firebase.auth().signOut()
}

export async function getAuthState () {
  // eslint-disable-next-line
  while (storedState.authState === AUTH_STATE_AUTHING) {
    await delay(1)
    console.log('waiting auth')
  }
  return storedState.authState === AUTH_STATE_AUTHED
}

export function getFireBaseDb () {
  return firebase.database()
}

export function getDeviceRef () {
  return firebase.database().ref('device')
}

export function getDeviceOnlineRef () {
  return firebase.database().ref('devices_online')
}

export function getUserRef () {
  return firebase.database().ref('user')
}

/* global Blob, URL */
export function exportCsv (items, headers, fileTitle) {
  if (headers) {
    items.unshift(headers)
  }

  // Convert obj to csv format
  var csv = ''
  for (var item of items) {
    var line = ''
    for (var key in item) {
      if (line !== '') line += ','
      line += typeof item[key] === 'string'
        ? item[key].replace(/,/g, '')
        : item[key]
    }
    csv += line + '\r\n'
  }

  var exportedFilenmae = fileTitle + '.csv' || 'export.csv'

  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae)
  } else {
    var link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', exportedFilenmae)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}



// WEBPACK FOOTER //
// ./src/index.js